let makePost=function(module, action, userdata, loader, cb) {
	let url = 'https://sale.katris.ru/proxy/';
	let key = 'W5pRNSx8Dx3tGY65xx3BOgAAAAE';

	let auth={};

	if (typeof userdata === "undefined" || userdata==null)  userdata={};
	if (navigator.onLine) {
		let xmlhttp = new XMLHttpRequest();
		xmlhttp.onreadystatechange = function () {
			if (xmlhttp.readyState === XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
				if (xmlhttp.status === 200) {
					// console.log('or', xmlhttp.responseText);
					let respond = JSON.parse(xmlhttp.responseText);
					if (typeof loader !== "undefined" && loader != null) loader.hide();
					if (typeof cb !== "undefined" && cb != null) cb(respond);
				} else {
					if (cb) cb({status: 'ERROR'});
					console.log('ОШИБКИ AJAX запроса:');
				}
			}
		};
		xmlhttp.open("POST", url, true);
		let data = new FormData();

		data.append('json', JSON.stringify({
			auth: auth,
			data: userdata,
			module: module,
			cmd: action,
			key: key
		}));
		xmlhttp.send(data);
	} //else alert('Отсутствует подключение к Интернет');
};

export default makePost;
